import React from "react";
import { Box, Chip, Typography } from "@mui/material";

interface RankedCellProps {
  value: number;
  label: string;
}

export const RankedCell: React.FC<RankedCellProps> = ({ value, label }) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <Typography variant="body1" sx={{ fontWeight: "bold", color: "#1e8e3e" }}>
        {value}
      </Typography>
      <Chip
        label={label}
        size="small"
        sx={{
          backgroundColor: "#EAF7EE",
          color: "#1e8e3e",
          fontWeight: "500",
        }}
      />
    </Box>
  );
};